import React from 'react';
import { Constants } from '../../shared/utils/constants';
import SpzaComponent from '../../shared/components/spzaComponent';
export class MicrosoftManagedIndicatorWrapper extends SpzaComponent {
    renderImpl() {
        var _app_licenseManagement;
        const { uiRole, app, isAvailableInRegion, renderIndicator } = this.props;
        const userIsAdmin = uiRole === Constants.UiRole.Admin;
        if (!(app === null || app === void 0 ? void 0 : (_app_licenseManagement = app.licenseManagement) === null || _app_licenseManagement === void 0 ? void 0 : _app_licenseManagement.isMicrosoftManaged) || !isAvailableInRegion || !uiRole || userIsAdmin) {
            return null;
        }
        return renderIndicator();
    }
}
